import ReactGA from 'react-ga4';
import { GoogleAnalyticsEvent } from 'types/google-analytics';

// ========================|| Google Analytics Event Handle  ||======================== //

/**
 * Handles Google Analytics event tracking.
 *
 * @param {GoogleAnalyticsEvent} event - Object containing the event properties: category, action, label (optional), value (optional)
 * @return {void}
 */
export const GoogleAnalyticsEventHandler = (event: GoogleAnalyticsEvent): void => {
    ReactGA.event(event);
};

export const initializeGoogleAnalytics = () => {
    if (process.env.NODE_ENV === 'production') ReactGA.initialize(process.env.REACT_APP_GOOGLE_MEASUREMENT_ID ?? '');
};
